/**
 * This is a test hook to simulate the wifi scanning in WifiNetworks component for local development.
 */

import { WSMBoltWifiNetwork } from "@WahooFitness/wsm-native/dist/esm/types/bolt_wifi";
import { useMemo } from "react";

const useWifiMock = ({ emptyScan }: { emptyScan: boolean }) => {
  // For testing locally
  const wifiEnabled = true;
  const wifiNetworksEmpty: WSMBoltWifiNetwork[] = useMemo(() => [], []);

  const wifiNetworks: WSMBoltWifiNetwork[] = useMemo(
    () => [
      {
        id: 1234,
        ssid: "My Network",
        securityType: 2,
        signalLevel: 176,
        isAvailable: true,
        isConnected: true,
        isSaved: true,
        hasAuthError: false,
      },
      {
        id: 1985,
        ssid: "My Network No Auth",
        securityType: 2,
        signalLevel: 176,
        isAvailable: true,
        isConnected: false,
        isSaved: false,
        hasAuthError: true,
      },
      {
        id: 1235,
        ssid: "My Network-Guest",
        securityType: 2,
        signalLevel: 175,
        isAvailable: true,
        isConnected: false,
        isSaved: true,
        hasAuthError: false,
      },
      {
        id: 1236,
        ssid: "Not My Network",
        securityType: 2,
        signalLevel: 100,
        isAvailable: true,
        isConnected: false,
        isSaved: false,
        hasAuthError: false,
      },
      {
        id: 1237,
        ssid: "Not My Network-Guest",
        securityType: 2,
        signalLevel: 50,
        isAvailable: true,
        isConnected: false,
        isSaved: false,
        hasAuthError: false,
      },
      {
        id: 1238,
        ssid: "HP LaserJet",
        securityType: 0,
        signalLevel: 20,
        isAvailable: true,
        isConnected: false,
        isSaved: false,
        hasAuthError: false,
      },
      {
        id: 1239,
        ssid: "HP LaserJet",
        securityType: 2,
        signalLevel: 20,
        isAvailable: true,
        isConnected: false,
        isSaved: false,
        hasAuthError: false,
      },
      {
        id: 1240,
        ssid: "HP LaserJet",
        securityType: 2,
        signalLevel: 20,
        isAvailable: true,
        isConnected: false,
        isSaved: false,
        hasAuthError: false,
      },
      {
        id: 1241,
        ssid: "HP LaserJet",
        securityType: 2,
        signalLevel: 20,
        isAvailable: true,
        isConnected: false,
        isSaved: false,
        hasAuthError: false,
      },
      {
        id: 1242,
        ssid: "HP LaserJet",
        securityType: 2,
        signalLevel: 20,
        isAvailable: true,
        isConnected: false,
        isSaved: false,
        hasAuthError: false,
      },
      {
        id: 1243,
        ssid: "HP LaserJet",
        securityType: 2,
        signalLevel: 20,
        isAvailable: true,
        isConnected: false,
        isSaved: false,
        hasAuthError: false,
      },
    ],
    []
  );

  return {
    wifiEnabled,
    wifiNetworks: emptyScan ? wifiNetworksEmpty : wifiNetworks,
  };
};

export { useWifiMock };
